import BackupList from '../components/backup/List'
import BackupCreate from '../components/backup/Create'
import BackupUpdate from '../components/backup/Update'
import BackupShow from '../components/backup/Show'

export default [
  {
    name: 'BackupList', path: '/backups/', component: BackupList, meta: {
      requiresAuth: true
    }
  },
  {
    name: 'BackupCreate', path: '/backups/create', component: BackupCreate, meta: {
      requiresAuth: true
    }
  },
  {
    name: 'BackupUpdate', path: '/backups/edit/:id', component: BackupUpdate, meta: {
      requiresAuth: true
    }
  },
  {
    name: 'BackupShow', path: '/backups/show/:id', component: BackupShow, meta: {
      requiresAuth: true
    }
  }
]
